import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const SidebarWrapper = styled.div`
  width: var(--sidebarWidth);
  background-color: #181616; /* Dark background color */
  color: #fff; /* Text color */
  height: 100vh;
  position: fixed;
  left: 0;
  display: flex;
  flex-direction: column; /* Stack child components vertically */

  @media (max-width: 930px) {
    width: 10rem;
  }
`;

export const Logo1 = styled.h5`
  border: 3px solid var(--main-color);
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  margin-left: 1rem;
  margin-top: 0.5rem;

  @media screen and (max-width: 375px) {
    font-size: 1.1rem;
  }
`;

export const Logo2 = styled.h5`
  line-height: 1;
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  margin-top: 0.5rem;
  font-weight: bold;

  @media screen and (max-width: 375px) {
    font-size: 1.1rem;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  margin-top: 0.5rem;

  @media screen and (max-width: 425px) {
    padding-right: 2rem;
    margin-left: -1rem;
  }
`;

export const Flagpole = styled.h2`
  text-align: center;
  margin-top: 1rem;
  color: var(--main-color);
`;

export const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const MenuItem = styled.li`
  padding: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  background-color: ${({ isactive }) => (isactive ? 'var(--main-color)' : 'transparent')};

  &:hover {
    background-color: #6161FF;
    svg {
      color: #fff;
    }
  }

  &.active {
    background-color: #6161FF;
    svg {
      color: #fff;
    }
  }
`;

export const NavLinkStyled = styled(NavLink)`
  text-decoration: none;
  color: #fff; /* Link text color */
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;

  svg {
    margin-right: 10px;
    color: var(--main-color); /* Icon color */
  }

  /* Override the default link color to be white */
  &:link,
  &:visited {
    color: #fff;
  }

  &.active {
    
    /* Change icon color to white when MenuItem is active */
    svg {
      color: #fff;
    }
  }
`;

export const MenuText = styled.div`
  @media (max-width: 930px) {
    display: none;
  }
`